import { server_endpoint } from "../store";
import axios from "axios";

export const createCourseAction = (formdata) => async (dispatch) => {
    try {
      dispatch({
        type: "createCourseRequest",
      });

  
      const data = await axios.post(`${server_endpoint}/createcourse`, formdata,  {
        headers: {
            "Content-Type": "multipart/form-data",
          },
        withCredentials: true,
      });
  
    //   console.log(data);
      dispatch({
        type: "createCourseSuccess",
        payload: data.data,
      });
    } catch (error) {
      // console.log(error);
      dispatch({
        type: "createCourseFail",
        payload: error?.response?.data?.message,
      });
    }
  };


  export const deleteCourseAction = (_id) => async (dispatch) => {
    try {
      dispatch({
        type: "deleteCourseRequest",
      });

  
      const data = await axios.delete(`${server_endpoint}/course/${_id}`,  {
        headers: {
            "Content-Type": "application/json",
          },
        withCredentials: true,
      });
  
    //   console.log(data);
      dispatch({
        type: "deleteCourseSuccess",
        payload: data.data,
      });
    } catch (error) {
      // console.log(error);
      dispatch({
        type: "deleteCourseFail",
        payload: error?.response?.data?.message,
      });
    }
  };


  export const addLecturesAction = (formdata) => async (dispatch) => {
    try {
      dispatch({
        type: "addLecturesRequest",
      });

  
      const data = await axios.post(`${server_endpoint}/course`, formdata, {
        headers: {
            "Content-Type": "multipart/form-data",
          },
        withCredentials: true,
      });
  
    //   console.log(data);
      dispatch({
        type: "addLecturesSuccess",
        payload: data.data,
      });
    } catch (error) {
      // console.log(error);
      dispatch({
        type: "addLecturesFail",
        payload: error?.response?.data?.message,
      });
    }
  };


  export const deleteLecturesAction = (course_id, lecture_id) => async (dispatch) => {
    try {
      dispatch({
        type: "deleteLecturesRequest",
      });

  
      const data = await axios.delete(`${server_endpoint}/lectures?courseId=${course_id}&lectureId=${lecture_id}`, {
        headers: {
            "Content-Type": "application/json",
          },
        withCredentials: true,
      });
  
    //   console.log(data);
      dispatch({
        type: "deleteLecturesSuccess",
        payload: data.data,
      });
    } catch (error) {
      // console.log(error);
      dispatch({
        type: "deleteLecturesFail",
        payload: error?.response?.data?.message,
      });
    }
  };


   export const getAllUsersAction = () => async (dispatch) => {
    try {
      dispatch({
        type: "getAllUsersRequest",
      });

  
      const data = await axios.get(`${server_endpoint}/admin/users`,  {
        headers: {
            "Content-Type": "application/json",
          },
        withCredentials: true,
      });
  
    //   console.log(data);
      dispatch({
        type: "getAllUsersSuccess",
        payload: data.data,
      });
    } catch (error) {
      // console.log(error);
      dispatch({
        type: "getAllUsersFail",
        payload: error?.response?.data?.message,
      });
    }
  };

  export const deleteUserAction = (_id) => async (dispatch) => {
    try {
      dispatch({
        type: "deleteAllUserRequest",
      });

  
      const data = await axios.delete(`${server_endpoint}/admin/deleteuser/${_id}`,  {
        headers: {
            "Content-Type": "application/json",
          },
        withCredentials: true,
      });
  
    //   console.log(data);
      dispatch({
        type: "deleteAllUserSuccess",
        payload: data.data,
      });
    } catch (error) {
      // console.log(error);
      dispatch({
        type: "deleteAllUserFail",
        payload: error?.response?.data?.message,
      });
    }
  };

  export const getDashboardStatsAction = () => async (dispatch) => {
    try {
      dispatch({
        type: "getAdminStatsRequest",
      });

  
      const data = await axios.get(`${server_endpoint}/stats`,  {
        headers: {
            "Content-Type": "application/json",
          },
        withCredentials: true,
      });
  
    //   console.log(data);
      dispatch({
        type: "getAdminStatsSuccess",
        payload: data.data,
      });
    } catch (error) {
      // console.log(error);
      dispatch({
        type: "getAdminStatsFail",
        payload: error?.response?.data?.message,
      });
    }
  };